import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const TEACHER = 'teacher'

/**
 * Form model
 */
const formModel = () => {
  return {
    [TEACHER]: {
      label: `${t('common.teacher')}`,
      name: TEACHER,
      required: true,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [TEACHER]: null,
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [TEACHER]: yup
       .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
  })

export default formModel
